<div class="ion-page modal-body fixed" scrollY="true">
  <div class="modalInnerWrapper modal-content">
    <div class="modal-body">

        <div class="row my-4">
          <div class="col-12">
            <h4 class="t-h4 t-medium">{{ 'PAGES.BOOK_OF_RULES.TITLE' | translate }}</h4>
          </div>
        </div>
        <div class="row">
          <div class="col-12 scrollContent">
            <div *ngFor="let rule of ruleSet; index as i" class="betting-category card-collapsible mb-2">
              <div (click)="toggleRule($event,rule)" class="card-header">
                <div class="text t-small t-strong text-uppercase dropdown-toggle-chevron collapsed" data-toggle="collapse"
                  [attr.data-target]="'#id' + i">
                  {{ rule.ruleDesc }}
                </div>
              </div>
              <div id="id{{i}}" class="collapse" style="">
                <div *ngIf="isRuleShown(rule)" class="card-body" style="color: #000;" [innerHTML]='rule.items[0]'>
                </div>
              </div>
            </div>
          </div>
        </div>
      
      
      
    </div>
    <ion-icon class="close icon icon-close" (click)="dismiss()" name="close-sharp"></ion-icon>
  </div>
</div>